/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionsent1Inputs */

const en_actionsent1 = /** @type {(inputs: Actionsent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action sent`)
};

const de_actionsent1 = /** @type {(inputs: Actionsent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktion geschaltet`)
};

/**
* | output |
* | --- |
* | "Action sent" |
*
* @param {Actionsent1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionsent1 = /** @type {((inputs?: Actionsent1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionsent1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionsent1(inputs)
	return de_actionsent1(inputs)
});
export { actionsent1 as "actionSent" }